import apiClient from './apiClient';

export async function login(email, password) {
  const { data } = await apiClient.post('/api/users/login', { email, password });
  if (data.success && data.token) {
    localStorage.setItem('admin_token', data.token);
    localStorage.setItem('admin_role', data.role);
    localStorage.setItem('admin_email', email);
  }
  return data;
}

export function logout() {
  localStorage.removeItem('admin_token');
  localStorage.removeItem('admin_role');
  localStorage.removeItem('admin_email');
}

export function getStoredAuth() {
  return {
    token: localStorage.getItem('admin_token'),
    role: localStorage.getItem('admin_role'),
    email: localStorage.getItem('admin_email'),
  };
}

export function isAuthenticated() {
  return !!localStorage.getItem('admin_token');
}

export function isAdmin() {
  return localStorage.getItem('admin_role') === 'admin';
}
